function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFECEC;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{display:none;mask:url(#SVGID_1_);fill:#444354;fill-opacity:0.75;}\n\t.st4{fill:#C19ABD;}\n\t.st5{fill:none;stroke:#9D959C;stroke-width:3.493;stroke-miterlimit:10;}\n\t.st6{fill:#F4F7F8;}\n\t.st7{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st8{mask:url(#SVGID_2_);fill:#724279;fill-opacity:0.75;}\n\t.st9{fill:#D1B4CE;}\n\t.st10{fill:none;stroke:#95719B;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st11{fill:#95719B;}\n\t.st12{fill:#B1A0BB;}\n\t.st13{fill:#D3ECEE;}\n\t.st14{fill:#9A7CA2;}\n\t.st15{fill:none;stroke:#633A69;stroke-width:2.8172;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#633A69;stroke-width:1.4086;stroke-miterlimit:10;}\n\t.st17{fill:#C3B5CB;}\n\t.st18{fill:#E7F5F6;}\n\t.st19{fill:#A78DAE;}\n\t.st20{display:none;fill:#A6B0BF;}\n\t.st21{fill:#A2B2EE;}\n\t.st22{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st23{opacity:0.2;mask:url(#SVGID_3_);}\n\t.st24{fill:#724279;}\n\t.st25{fill:#C19ABD;enable-background:new    ;}\n\t.st26{fill:#F2F2F2;stroke:#724279;stroke-width:1.3972;stroke-miterlimit:10;}\n\t.st27{fill:#FF6584;}\n\t.st28{fill:#F2F2F2;stroke:#633A69;stroke-width:1.3972;stroke-miterlimit:10;}\n\t.st29{fill:#81ADEF;stroke:#81ADEF;stroke-width:1.3972;stroke-miterlimit:10;}\n\t.st30{fill:#D1B4CE;enable-background:new    ;}\n\t.st31{fill:#EA3434;}\n\t.st32{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st33{fill:none;stroke:#FFFFFF;stroke-width:2.3448;stroke-miterlimit:10;}\n\t.st34{fill:none;stroke:#FFFFFF;stroke-width:2.7944;stroke-miterlimit:10;}\n\t.st35{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2.7944;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st36{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st37{fill:#F2F2F2;}\n\t.st38{opacity:0.2;mask:url(#SVGID_4_);fill:#633A69;fill-opacity:0.99;enable-background:new    ;}\n\t.st39{fill:#A3C3F3;stroke:#A3C3F3;stroke-width:1.3972;stroke-miterlimit:10;}\n\t.st40{fill:#EC4847;}\n\t.st41{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.6986;stroke-miterlimit:10;}\n\t.st42{fill:none;stroke:#95719B;stroke-width:2;stroke-miterlimit:10;}\n\t.st43{display:none;}\n\t.st44{display:inline;fill:#7575D8;}\n\t.st45{opacity:0.15;fill:#C19ABD;enable-background:new    ;}\n\t.st46{opacity:0.52;fill:#C19ABD;enable-background:new    ;}\n\t.st47{fill:none;stroke:#633A69;stroke-width:2.636;stroke-miterlimit:10;}\n\t.st48{fill:none;stroke:#633A69;stroke-width:3.2065;stroke-miterlimit:10;}\n\t.st49{opacity:0.15;fill:none;stroke:#633A69;stroke-width:2.8172;stroke-miterlimit:10;enable-background:new    ;}\n\t.st50{fill:#FFE3E3;}\n\t.st51{fill:#C7CBE6;}\n\t.st52{fill:#C4B2DC;}\n\t.st53{opacity:0.15;enable-background:new    ;}\n\t.st54{fill:#7A66A3;}\n\t.st55{fill:#FCFDFC;}\n\t.st56{fill:#C6A7C4;}\n\t.st57{fill:#9094CB;}\n\t.st58{opacity:0.15;fill:#D1B4CE;enable-background:new    ;}\n\t.st59{opacity:0.52;fill:#D1B4CE;enable-background:new    ;}\n\t.st60{opacity:0.18;fill:none;stroke:#633A69;stroke-width:2.8172;stroke-miterlimit:10;}\n\t.st61{fill:#D7DAED;}\n\t.st62{fill:#DE3F41;}\n\t.st63{fill:#ADB0D8;}\n\t.st64{fill:none;stroke:#AAA2A9;stroke-width:3.493;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Back_Graph"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1410.486,63.371c0,0-160.6-61.096-326.31-35.232c-43.056,6.72-83.821,21.272-119.888,42.084 c-31.899,18.407-74.347,45.616-101.701,73.817c-43.185,44.523-117.373,149.803-223.461,210.68 c-25.488,14.626-73.635,28.602-120.288,39.791c-55.832,13.39-113.028,22.341-170.788,27.41 c-42.239,3.707-101.166,12.718-133.406,34.615c-34.594,23.496-43.658,41.84-43.944,42.293 c-21.434,33.947-20.35,82.745,3.74,116.696c8.197,11.552,19.949,24.995,36.464,37.593c52.359,39.943,160.817,59.523,160.817,59.523 s123.68,25.9,115.139,97.842c-0.685,5.771-0.758,11.599-0.414,17.4l0.266,4.485c0.291,4.903,0.94,9.78,1.947,14.588 c1.633,7.797,3.043,13.512,13.033,29.937c28.894,47.509,90.233,64.56,144.448,52.2l342.481-77.469 c0.464-0.105,0.929-0.21,1.394-0.314c49.554-11.086,100.879-11.683,150.773-2.243l134.042,25.36 c31.839,6.024,64.981,0.072,92.181-17.539c25.124-16.267,43.044-40.708,43.476-70.339V63.371z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 23.475,
  y: 49.157,
  width: 1413.664,
  height: 773.824
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 23.475,
  y: 49.157,
  width: 1413.664,
  height: 773.824,
  id: "SVGID_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("rect", {
  x: -403.611,
  y: 42.468,
  className: "st2",
  width: 1299.727,
  height: 1003.576
}))), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M949.42,251.012L918.402,361.18c-3.353-0.629-6.706,1.257-7.824,4.541l0,0l-67.344-16.137l104.16-99.829 C947.953,250.313,948.651,250.732,949.42,251.012z M1371.02,704.887c-0.14,0.419-0.279,0.908-0.279,1.327l-57.773-7.475 l-70.628-9.082c0.07-0.699,0.07-1.327,0-1.956l119.948-50.159l13.622,62.873C1373.674,700.975,1371.788,702.581,1371.02,704.887z  M891.646,617.842c-1.677,0-3.283,0.629-4.541,1.677l-47.155-45.478l60.149-70.278c0.559,0.349,1.118,0.699,1.747,0.908 c0.279,0.07,0.629,0.21,0.908,0.21L891.646,617.842z M696.739,580.747c-0.978-0.349-2.026-0.419-3.004-0.349l-20.818-102.553 l32.624,92.633l-7.615,10.758C697.508,581.096,697.159,580.887,696.739,580.747z M470.535,623.082l-109.819-92.913l41.426-64.969 c0.279,0.14,0.629,0.279,0.908,0.419c1.467,0.489,2.934,0.489,4.261,0.07l64.759,156.275 C471.513,622.173,471.024,622.593,470.535,623.082z M264.311,758.678l-74.47-39.82l77.194-47.434 c0.768,1.048,1.886,1.816,3.214,2.305c0.419,0.14,0.838,0.279,1.327,0.279l-1.537,81.456 C267.734,755.535,265.569,756.722,264.311,758.678z M188.514,718.16L56.899,647.672c0.07-0.14,0.14-0.279,0.21-0.419 c0.07-0.279,0.21-0.629,0.21-0.908l208.32,21.028c0,1.048,0.279,2.026,0.768,2.934L188.514,718.16z M32.728,809.466 c-0.279-0.07-0.559-0.14-0.768-0.21l18.443-157.323c2.375,0.07,4.611-1.118,5.938-3.144l130.986,70.139L36.012,811.841 C35.173,810.793,34.055,809.885,32.728,809.466z M542.909,295.233c-0.349,1.327-0.21,2.724,0.21,3.982l-90.538,42.265 l-35.908-84.949c1.327-0.699,2.375-1.816,3.074-3.283L542.909,295.233z M1272.099,413.225c1.607,0.559,3.353,0.489,4.82-0.14 l60.638,118.341c-0.489,0.349-0.978,0.699-1.397,1.188l-131.964-99.759l63.921-23.263 C1268.816,411.269,1270.283,412.596,1272.099,413.225z M1180.724,446.687l154.249,87.743c-0.07,0.21-0.14,0.419-0.279,0.629 c-0.419,1.188-0.489,2.445-0.21,3.563l-125.746,37.235l-31.367-126.585C1178.628,448.783,1179.885,447.945,1180.724,446.687z  M1333.016,531.846l-151.664-86.276c0.07-0.21,0.14-0.419,0.28-0.629c0.489-1.327,0.489-2.725,0.14-3.982l20.958-7.615 L1333.016,531.846z M1172.76,449.272c0.279,0.07,0.559,0.14,0.838,0.21l-14.95,134.828c-1.188,0-2.375,0.279-3.423,0.838 l-56.097-85.508l70.767-52.325C1170.594,448.224,1171.642,448.923,1172.76,449.272z M989.659,579.07 c-0.21-0.21-0.419-0.489-0.629-0.699l78.941-113.731c0.349,0.21,0.768,0.419,1.188,0.559c1.886,0.629,3.842,0.419,5.449-0.419 l22.704,34.65L989.659,579.07z M1066.923,463.873l-78.941,113.661c-0.489-0.279-0.978-0.559-1.537-0.768 c-1.118-0.349-2.235-0.489-3.283-0.279l-28.153-89.769l109.819-25.988C1065.246,461.986,1065.945,463.104,1066.923,463.873z  M910.648,495.938c-0.699-1.956-2.235-3.633-4.331-4.331c-0.279-0.07-0.629-0.21-0.908-0.21l11.666-116.385 c0.489,0,0.978-0.07,1.467-0.14l34.79,111.076L910.648,495.938z M459.917,519.271l-19.84-62.664l50.718-5.589 c0.419,1.886,1.537,3.563,3.214,4.541l-30.319,63.712C462.432,518.922,461.104,518.922,459.917,519.271z M546.822,303.197 l-47.644,139.648c-1.257-0.279-2.515-0.21-3.703,0.14l-42.405-100.318l90.537-42.265 C544.377,301.59,545.424,302.568,546.822,303.197z M897.514,495.658c-0.21,0.489-0.279,1.048-0.349,1.537l-131.754-0.559 c0.07-0.629,0-1.257-0.14-1.886l63.502-52.814l69.37,52.255C897.934,494.68,897.724,495.169,897.514,495.658z M914.909,374.593 c0.279,0.07,0.629,0.21,0.908,0.21l-2.445,24.241l-9.221,92.214c-1.956,0-3.842,0.838-5.17,2.236l-69.091-52.115l82.364-68.462 C912.953,373.615,913.862,374.243,914.909,374.593z M827.795,441.448l-62.873,52.255c-0.349-0.838-0.838-1.537-1.467-2.236 l15.648-66.296l2.794-11.806c2.235,0.349,4.471-0.489,6.008-2.096L827.795,441.448z M780.57,413.155L780.57,413.155l-18.303,77.474 c-0.489-0.279-0.978-0.559-1.537-0.768c-0.908-0.279-1.816-0.419-2.724-0.349l-26.896-53.652l46.037-25.289 C777.986,411.758,779.173,412.666,780.57,413.155z M675.921,464.781c-0.838-1.048-1.886-1.886-3.283-2.375 c-0.559-0.21-1.048-0.279-1.607-0.349v-0.07l-4.401-148.101c0.559-0.07,1.118-0.21,1.677-0.419L729.433,435.3L675.921,464.781z  M405.287,452.066c-2.236,0-4.331,1.118-5.589,2.934l-43.872-25.359l49.74-61.965c0.489,0.349,0.978,0.559,1.607,0.768 c0.14,0.07,0.349,0.07,0.489,0.14L405.287,452.066z M493.1,444.242l-78.382-77.963c0.489-0.629,0.908-1.327,1.188-2.166 c0.489-1.397,0.489-2.864,0.07-4.192l35.908-16.766l42.405,100.318C493.868,443.683,493.519,443.963,493.1,444.242z  M411.155,257.02c0.419,0.14,0.908,0.279,1.327,0.279l-1.327,36.117l-2.236,61.546c-0.419,0-0.768,0.07-1.118,0.14l-25.778-77.194 l26.546-22.564C409.269,256.111,410.177,256.67,411.155,257.02z M406.614,355.521c-1.746,0.768-3.144,2.166-3.772,4.122 c-0.279,0.768-0.349,1.537-0.349,2.305L270.948,375.92c-0.21-0.908-0.559-1.816-1.118-2.585l111.216-94.519L406.614,355.521z  M270.668,379.553c0.279-0.768,0.349-1.537,0.349-2.305l131.545-13.972c0.279,1.397,0.978,2.655,1.956,3.633l-49.879,62.105 l-84.32-48.762C270.529,379.972,270.599,379.762,270.668,379.553z M413.53,367.397l78.661,77.753 c-0.489,0.629-0.908,1.327-1.188,2.166c-0.279,0.768-0.349,1.607-0.349,2.375l-50.997,5.659l-27.594-87.045 C412.622,368.026,413.111,367.746,413.53,367.397z M663.836,466.737c0,0.07-0.07,0.21-0.07,0.279l-96.755-10.549l-62.524-6.776 c0-1.467-0.419-2.864-1.257-4.052l94.17-79.779l68.881,97.593C665.163,464.222,664.325,465.34,663.836,466.737z M415.556,358.735 c-0.768-1.537-2.166-2.794-3.912-3.423c-0.419-0.14-0.908-0.279-1.327-0.279l3.493-97.663c0.559,0,1.188-0.14,1.677-0.349 l35.908,84.949L415.556,358.735z M408.64,245.423c-0.768,0.768-1.397,1.677-1.816,2.794c-0.768,2.166-0.349,4.471,0.908,6.217 l-26.127,22.215L344.3,164.875c0.349-0.14,0.629-0.349,0.908-0.489l39.051,49.879L408.64,245.423z M339.829,165.295 c1.118,0.279,2.236,0.21,3.214-0.07l37.444,112.264l-111.565,94.869c-0.559-0.559-1.188-0.978-1.956-1.327L339.829,165.295z  M269.76,381.299l84.11,48.692l-41.217,51.346c-0.489-0.349-0.978-0.559-1.607-0.768c-1.397-0.489-2.934-0.489-4.261-0.07 l-39.54-96.964C268.293,382.976,269.132,382.207,269.76,381.299z M313.702,482.106l41.357-51.486l44.011,25.499 c-0.07,0.21-0.21,0.419-0.279,0.699c-0.419,1.188-0.489,2.375-0.21,3.563l-83.272,24.241 C314.959,483.643,314.4,482.804,313.702,482.106z M407.592,452.486c-0.349-0.14-0.699-0.21-0.978-0.279l2.375-83.412 c0.629,0.07,1.327,0,1.886-0.14l27.525,86.835l-26.127,2.864C411.993,455.699,410.247,453.394,407.592,452.486z M676.62,465.829 l53.372-29.341l26.686,53.303c-2.026,0.559-3.772,2.026-4.611,4.122l-74.749-24.032 C677.458,468.483,677.249,467.086,676.62,465.829z M911.417,371.938l-82.643,68.672l-40.169-30.249 c0.279-0.489,0.559-0.978,0.768-1.537c0.419-1.118,0.489-2.305,0.279-3.423l120.996-34.86 C910.858,371.03,911.137,371.519,911.417,371.938z M776.239,404.353c-0.559,1.746-0.419,3.563,0.279,5.1l-45.967,25.289 l-61.057-121.834c0.419-0.279,0.838-0.559,1.188-0.908l106.465,90.747C776.728,403.235,776.449,403.794,776.239,404.353z  M663.556,313.606c0.629,0.21,1.188,0.279,1.816,0.349l4.401,148.101c-0.838,0.07-1.677,0.279-2.375,0.699l-68.951-97.803 l62.524-52.953C661.67,312.697,662.578,313.256,663.556,313.606z M502.391,444.591c-0.559-0.559-1.257-1.048-2.026-1.397 l47.574-139.648c1.746,0.419,3.563,0.14,5.1-0.699l43.662,61.895L502.391,444.591z M261.377,370.89l-47.774-63.364 c2.267-4.957-1.136-8.065-1.136-8.065l124.916-135.285c0.279,0.21,0.629,0.419,0.978,0.559l0.14,0.419l-72.723,205.386 C264.241,370.122,262.705,370.331,261.377,370.89 M216.108,462.056l-48.343,85.787c-7.069-1.092-8.732,4.331-8.732,4.331 c-1.257,3.633,0.699,7.545,4.331,8.802c0.629,0.21,1.257,0.349,1.886,0.349l5.1,70.488c-2.445,0.419-4.541,2.096-5.449,4.611 c-0.21,0.629-0.349,1.327-0.349,1.956l-107.234,5.659c-0.349-2.515-2.096-4.681-4.611-5.589c-3.633-1.257-7.545,0.699-8.802,4.331 c-1.257,3.633,0.699,7.545,4.331,8.802c0.279,0.07,0.559,0.14,0.768,0.21L30.563,809.116c-2.934-0.07-5.728,1.746-6.706,4.681 c-1.257,3.633,0.699,7.545,4.331,8.802s7.545-0.699,8.802-4.331c0.349-1.048,0.419-2.096,0.279-3.074l226.344-50.229 c0.699,1.816,2.235,3.353,4.261,4.052c3.633,1.258,7.545-0.699,8.802-4.331c1.257-3.633-0.699-7.545-4.331-8.802 c-0.349-0.14-0.699-0.21-1.118-0.279l1.537-81.526c2.724-0.14,5.239-1.886,6.217-4.681c0.279-0.908,0.419-1.816,0.349-2.725 l189.318-36.746c0.629,2.096,2.166,3.842,4.401,4.611c3.633,1.257,7.545-0.699,8.802-4.331c1.257-3.633-0.699-7.545-4.331-8.802 c-0.838-0.279-1.677-0.419-2.515-0.349l-11.736-88.442c2.236-0.489,4.192-2.166,5.03-4.541l-0.14,0.629l219.358,57.424 c-0.559,3.283,1.327,6.567,4.611,7.685c1.677,0.559,3.423,0.489,4.96-0.21l44.78,83.552c-1.258,0.838-2.235,2.026-2.724,3.563 c-1.258,3.633,0.699,7.545,4.331,8.802c3.633,1.257,7.545-0.699,8.802-4.331c0.489-1.397,0.489-2.864,0.07-4.192l133.012-53.163 c0.768,1.537,2.166,2.794,3.912,3.423c3.633,1.258,7.545-0.699,8.802-4.331c0.489-1.537,0.489-3.074,0-4.471l80.059-35.768 c0.838,1.467,2.096,2.585,3.772,3.144c3.633,1.258,7.545-0.699,8.802-4.331c0.14-0.349,0.21-0.768,0.279-1.188l160.606,7.265 c0.21,2.724,1.956,5.17,4.681,6.078c2.026,0.699,4.192,0.349,5.938-0.699l68.462,86.555c-0.838,0.768-1.467,1.747-1.886,2.864 c-1.257,3.633,0.699,7.545,4.331,8.802c3.633,1.257,7.545-0.699,8.802-4.331v-0.07l128.68,16.626 c0.14,2.725,1.956,5.239,4.681,6.148c3.633,1.257,7.545-0.699,8.802-4.331c0.978-2.794,0-5.798-2.166-7.615L1427.675,614 c0.07,0.07,0.21,0.07,0.279,0.14c3.633,1.257,7.545-0.699,8.802-4.331c1.258-3.633-0.699-7.545-4.331-8.802 c-0.838-0.279-1.746-0.419-2.585-0.349l-8.732-91.585c2.375-0.419,4.471-2.096,5.239-4.541c1.258-3.633-0.699-7.545-4.331-8.802 c-2.864-0.978-5.868,0-7.615,2.236l-133.99-88.162c0.14-0.349,0.349-0.629,0.419-1.048c1.257-3.633-0.699-7.545-4.331-8.802 c-3.633-1.257-7.545,0.699-8.802,4.331c-0.21,0.559-0.279,1.188-0.349,1.746l-89.07,1.956c-0.279-2.585-2.026-4.89-4.611-5.798 c-3.633-1.257-7.545,0.699-8.802,4.331c-0.559,1.607-0.489,3.283,0.07,4.75l-87.673,43.522c-0.838-1.327-2.096-2.375-3.633-2.934 c-1.746-0.559-3.493-0.419-5.03,0.21L955.777,250.103c1.188-0.838,2.166-2.026,2.655-3.493c1.258-3.633-0.699-7.545-4.331-8.802 c-3.633-1.257-7.545,0.699-8.802,4.331c-0.349,1.048-0.419,2.166-0.279,3.144l-272.451,63.083c0.768-3.423-1.118-6.916-4.541-8.104 c-3.633-1.257-7.545,0.699-8.802,4.331c-0.14,0.349-0.21,0.699-0.279,0.978l-102.414-8.942c0-2.864-1.816-5.519-4.681-6.497 c-1.467-0.489-2.934-0.489-4.261-0.07l-49.81-120.158l1.746,0.14l-2.236-1.257l-0.279-0.699l-0.349,0.349L305.319,58.969 c0.07-0.21,0.21-0.419,0.279-0.629c1.257-3.633-0.699-7.545-4.331-8.802c-3.633-1.257-7.545,0.699-8.802,4.331 c-1.257,3.633,0.699,7.545,4.331,8.802c1.327,0.489,2.725,0.489,4.052,0.14l34.231,92.983c-0.07,0.14-0.14,0.349-0.21,0.559 c-0.279,0.908-0.419,1.816-0.349,2.725l-165.915,27.245c-0.559-2.166-2.166-4.052-4.471-4.82c-3.633-1.257-7.545,0.699-8.802,4.331 c-1.257,3.633,0.699,7.545,4.331,8.802c1.467,0.489,4.261,0.07,4.261,0.07L203.9,298.511c-2.437,1.709-3.16,3.312-3.16,6.121 c0,2.809,3.035,6.665,6.837,6.505c3.802-0.16,5.33-2.566,5.33-2.566c15.706,21.037,31.413,42.074,47.119,63.111 c-0.151,0.111-3.331,2.536-2.911,6.287c0.264,2.359,1.793,3.82,2.241,4.221 M261.307,383.674c0.21,0.07,0.349,0.14,0.559,0.21 c1.397,0.489,2.934,0.489,4.261,0.07l39.54,96.965c-1.537,0.768-2.794,2.166-3.353,3.912c-0.559,1.537-0.489,3.144,0.07,4.611 l-130.916,61.266c-0.559-0.838-1.257-1.607-2.166-2.166L261.307,383.674z M170.77,559.021c0.559-0.699,1.048-1.467,1.397-2.375 c0.559-1.607,0.489-3.353-0.14-4.82l130.846-61.266c0.279,0.419,0.559,0.838,0.838,1.188l-96.196,106.186L170.77,559.021z  M304.69,492.585c0.559,0.419,1.188,0.768,1.956,1.048c0.07,0,0.14,0.07,0.21,0.07l-33.742,166.544 c-1.886-0.14-3.703,0.419-5.1,1.607l-59.59-63.013L304.69,492.585z M267.106,662.762c-0.489,0.629-0.908,1.327-1.188,2.096 l-87.603-25.01c0.419-2.166-0.279-4.401-1.677-5.938l30.948-34.161L267.106,662.762z M177.965,641.105l87.254,24.87L58.855,645.157 l105.837-5.589c0.349,2.515,2.096,4.681,4.611,5.589C172.796,646.414,176.638,644.598,177.965,641.105z M274.72,660.596 c-0.14-0.07-0.21-0.07-0.349-0.07l33.742-166.544c2.096,0.21,4.122-0.489,5.589-1.956l45.339,38.353l-83.342,130.567 C275.349,660.806,275.07,660.666,274.72,660.596z M314.54,491.048c0.349-0.489,0.699-1.118,0.908-1.746 c0.419-1.188,0.489-2.375,0.21-3.563l83.272-24.171c0.419,1.118,1.188,2.166,2.166,2.934l-41.357,64.829L314.54,491.048z  M410.177,464.012c0.768-0.768,1.397-1.677,1.746-2.725c0.21-0.559,0.279-1.048,0.349-1.607l26.546-2.934l19.98,63.013 c-0.349,0.21-0.768,0.419-1.048,0.699L410.177,464.012z M464.877,519.69l30.319-63.642c0.07,0,0.07,0.07,0.14,0.07 c3.633,1.257,7.545-0.699,8.802-4.331c0.07-0.279,0.14-0.559,0.21-0.838l159.139,17.325c-0.07,0.489-0.07,0.908,0,1.397 L468.16,523.183C467.601,521.716,466.414,520.458,464.877,519.69z M673.337,475.26c1.677-0.768,3.004-2.166,3.633-4.052v-0.07 l74.749,24.032c-0.489,2.515,0.419,5.03,2.305,6.567L706.38,569.29L673.337,475.26z M755.072,502.435 c0.349,0.21,0.768,0.419,1.188,0.559c0.349,0.14,0.768,0.21,1.118,0.279l-11.806,172.832c-0.489,0-1.048,0.07-1.537,0.21 l-37.165-105.557L755.072,502.435z M748.016,676.454c-0.349-0.14-0.768-0.21-1.118-0.279l11.806-172.832 c1.607-0.07,3.144-0.629,4.331-1.677l75.099,72.444l-88.372,103.182C749.273,677.013,748.715,676.664,748.016,676.454z  M763.944,500.479c0.489-0.629,0.908-1.327,1.188-2.096c0.07-0.14,0.07-0.349,0.14-0.489l131.964,0.559 c0.14,1.607,0.838,3.074,1.956,4.192l-60.149,70.208L763.944,500.479z M909.321,502.714c0.559-0.699,1.048-1.467,1.327-2.375 c0.349-1.048,0.419-2.166,0.279-3.214l42.824-10.13l28.153,89.839c-0.629,0.21-1.258,0.559-1.746,0.908L909.321,502.714z  M990.357,580.118l107.723-79.709l56.097,85.438c-0.978,0.768-1.746,1.816-2.166,3.074c-0.14,0.489-0.279,0.978-0.349,1.397 l-160.536-7.265C991.126,582.074,990.846,581.026,990.357,580.118z M1160.814,584.659c-0.279-0.07-0.559-0.14-0.838-0.21 l14.95-134.758c0.419,0,0.768,0,1.188-0.07l31.367,126.655l-42.405,12.575C1164.376,586.895,1162.84,585.358,1160.814,584.659z  M1334.833,539.879c0.419,1.048,1.118,2.026,1.956,2.724L1239.685,683.3c-0.629-0.489-1.257-0.838-2.026-1.118 c-0.908-0.279-1.816-0.419-2.724-0.349l-25.988-104.719L1334.833,539.879z M1241.92,686.374c-0.279-0.838-0.768-1.537-1.327-2.236 l97.244-140.836c0.349,0.21,0.768,0.349,1.188,0.489c1.048,0.349,2.096,0.419,3.074,0.279l19.84,92.144L1241.92,686.374z  M1343.286,543.931c1.118-0.349,2.096-0.978,2.864-1.816l77.823,62.454c-0.14,0.279-0.279,0.559-0.419,0.908 c-0.559,1.677-0.489,3.353,0.14,4.89l-60.638,25.359L1343.286,543.931z M1425.021,603.102c-0.07,0.14-0.21,0.21-0.279,0.349 l-77.753-62.384c0.349-0.489,0.559-0.978,0.768-1.607c0.489-1.467,0.489-3.074,0-4.471l18.443-8.174L1425.021,603.102z  M1347.268,533.941c-0.838-1.467-2.096-2.585-3.772-3.214c-1.607-0.559-3.353-0.489-4.82,0.14l-60.568-118.341l87.324,113.312 L1347.268,533.941z M1267.628,408.404l-64.759,23.543l-25.568-19.351c0.28-0.419,0.489-0.908,0.699-1.397 c0.21-0.559,0.279-1.188,0.349-1.746l89.07-1.956C1267.489,407.776,1267.558,408.125,1267.628,408.404z M1176.602,413.644 l24.87,18.792l-20.189,7.335c-0.768-1.607-2.166-3.004-4.052-3.633c-0.768-0.279-1.537-0.349-2.305-0.349l-2.096-20.05 C1174.227,415.46,1175.554,414.692,1176.602,413.644z M1169.057,446.338l-70.628,52.255l-22.704-34.58 c0.978-0.768,1.816-1.886,2.235-3.144c0.279-0.908,0.419-1.746,0.349-2.655l89.979-13.762 C1168.498,445.081,1168.708,445.709,1169.057,446.338z M1064.827,456.398c-0.349,1.048-0.419,2.166-0.279,3.214l-109.888,25.918 L919.8,374.383c1.188-0.489,2.166-1.257,2.934-2.375l142.373,83.621C1065.037,455.909,1064.897,456.118,1064.827,456.398z  M910.299,367.048c-0.14,0.768-0.07,1.537,0.07,2.305l-120.996,34.86c-0.279-0.699-0.629-1.327-1.048-1.886l53.861-51.626 L910.299,367.048z M787.347,401.349c-0.629-0.559-1.397-1.048-2.305-1.327c-2.585-0.908-5.379-0.14-7.195,1.677L671.45,311.021 c0.279-0.349,0.489-0.768,0.629-1.118l168.5,40.448L787.347,401.349z M660.133,311.021l-62.454,52.883l-43.592-61.755 c0.908-0.768,1.677-1.816,2.096-3.004c0.14-0.349,0.21-0.699,0.279-0.978l102.414,8.942 C658.876,308.506,659.295,309.833,660.133,311.021z M543.329,294.045l-122.184-41.636l22.914-24.87l99.479,66.087 C543.468,293.766,543.398,293.905,543.329,294.045z M420.237,251.431c0.489-3.214-1.397-6.427-4.611-7.545 c-2.096-0.699-4.261-0.349-6.008,0.768l-63.432-81.106c0.21-0.21,0.419-0.419,0.559-0.629l96.196,63.921L420.237,251.431z  M205.188,297.866l-39.806-103.947c1.257-0.838,2.524-2.218,3.013-3.685c0.279-0.908,0.419-1.816,0.349-2.725l165.915-27.245 c0.279,1.118,0.908,2.166,1.677,3.074L211.233,298.481C208.24,296.581,205.188,297.866,205.188,297.866z M166.508,561.256 c1.188-0.14,2.375-0.629,3.283-1.397l36.886,38.981l-31.017,34.231c-0.559-0.419-1.188-0.768-1.956-1.048 c-0.699-0.21-1.397-0.349-2.096-0.349L166.508,561.256z M37.059,813.867c-0.07-0.349-0.21-0.629-0.349-0.978l151.874-93.332 l75.168,40.239c-0.07,0.14-0.07,0.21-0.14,0.349c-0.419,1.188-0.489,2.375-0.279,3.493L37.059,813.867z M279.191,665.416 c-0.349-1.467-1.257-2.794-2.445-3.703l83.272-130.427l109.679,92.843c-0.349,0.489-0.699,1.118-0.908,1.746 c-0.349,0.978-0.419,1.956-0.349,2.934L279.191,665.416z M473.819,621.265c-0.14,0.07-0.349,0.07-0.489,0.14L408.57,465.13 c0.21-0.07,0.419-0.21,0.559-0.349l47.574,56.446c-0.629,0.699-1.118,1.467-1.397,2.375c-1.257,3.633,0.699,7.545,4.331,8.802 c0.838,0.279,1.677,0.419,2.515,0.349L473.819,621.265z M468.579,527.514c0.279-1.048,0.279-2.166,0-3.144l195.186-53.442 c0.629,2.096,2.166,3.842,4.401,4.611c0.978,0.349,2.026,0.419,3.004,0.349l21.307,104.859c-2.026,0.629-3.703,2.166-4.541,4.261 L468.579,527.514z M701.001,589.549c0.978-2.794,0-5.728-2.096-7.475l7.056-9.99l36.397,103.392l-44.081-82.364 C699.534,592.274,700.512,591.086,701.001,589.549z M751.998,679.877c-0.279-0.629-0.699-1.188-1.188-1.677l88.302-103.182 l47.085,45.408c-0.489,0.629-0.908,1.327-1.188,2.096c-0.489,1.397-0.489,2.864-0.07,4.192L751.998,679.877z M897.654,621.405 c-0.838-1.467-2.096-2.585-3.772-3.144c-0.279-0.07-0.629-0.21-0.908-0.21l11.177-112.892c1.607,0,3.074-0.489,4.331-1.467 l70.767,75.029c-0.629,0.699-1.188,1.537-1.537,2.515c-0.489,1.537-0.489,3.074,0,4.471L897.654,621.405z M1163.259,596.326 c0.838-0.768,1.467-1.747,1.886-2.864c0.419-1.188,0.489-2.305,0.279-3.493l42.335-12.505l25.918,104.579 c-0.699,0.21-1.327,0.489-1.956,0.838L1163.259,596.326z M1380.87,701.044c-0.349-0.21-0.698-0.349-1.048-0.489 c-0.908-0.279-1.816-0.419-2.724-0.349l-13.623-63.223l60.987-25.499c0.559,0.838,1.258,1.537,2.166,2.096L1380.87,701.044z  M1428.584,601.006c-0.978,0.21-1.886,0.699-2.655,1.258l-58.542-75.867l46.386-20.539c0.838,1.467,2.096,2.585,3.772,3.214 c0.768,0.279,1.537,0.349,2.235,0.349L1428.584,601.006z M1413.774,499.151c-0.14,0.349-0.349,0.629-0.419,1.048 c-0.489,1.467-0.489,3.074,0,4.471l-46.666,20.678l-87.603-113.591c0.279-0.21,0.489-0.489,0.698-0.768L1413.774,499.151z  M1165.564,412.596c0.838,1.327,2.096,2.375,3.633,2.934c0.768,0.279,1.537,0.349,2.305,0.349l2.096,20.05 c-2.305,0.489-4.401,2.166-5.17,4.541c-0.28,0.908-0.419,1.746-0.349,2.655l-89.979,13.762c-0.07-0.279-0.14-0.559-0.279-0.838 L1165.564,412.596z M1067.482,452.905c-0.629,0.419-1.257,0.978-1.677,1.677L923.432,370.96c0.14-0.21,0.21-0.489,0.279-0.699 c1.188-3.563-0.629-7.335-4.052-8.663l31.018-110.168c1.397,0.279,2.794,0.07,4.052-0.489L1067.482,452.905z M946.486,248.916 L841.767,349.304l-166.614-40.029l270.145-62.524C945.578,247.519,945.997,248.287,946.486,248.916z M546.402,290.762 c-0.838,0.419-1.537,1.048-2.166,1.746l-99.34-65.947l51.626-55.957L546.402,290.762z M495.335,169.975l-51.556,55.887 l-96.266-63.991c0.21-0.349,0.349-0.699,0.489-1.048c0.14-0.349,0.21-0.768,0.279-1.118L495.335,169.975z M494.008,168.578 l-145.656-10.199c-0.07-2.794-1.886-5.449-4.681-6.427c-2.864-0.978-6.008,0.07-7.754,2.375l-33.882-91.935 c1.048-0.489,1.956-1.257,2.655-2.235L494.008,168.578z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M413.466,726.905h742.172c22.215,0,40.224-18.009,40.224-40.225V199.964c0-22.215-18.009-40.225-40.224-40.225 H413.466c-22.215,0-40.225,18.009-40.225,40.225V686.68C373.242,708.896,391.251,726.905,413.466,726.905z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 240.955,
  y1: 817.504,
  x2: 219.648,
  y2: 817.504
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 198.341,
  y1: 817.504,
  x2: 187.862,
  y2: 817.504
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 210.916,
  y1: 817.504,
  x2: 207.772,
  y2: 817.504
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 43.244,
  y1: 847.688,
  x2: 91.803,
  y2: 607.319
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 493.373,
  y1: 648.196,
  x2: 91.803,
  y2: 607.319
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 329.369,
  y1: 726.905,
  x2: 43.244,
  y2: 847.688
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 213.516,
  y1: 523.177,
  x2: 329.369,
  y2: 726.905
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.853,
  x2: 213.516,
  y2: 523.177
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 43.244,
  y1: 847.688,
  x2: 267.765,
  y2: 625.231
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 416.981,
  y1: 384.84,
  x2: 213.516,
  y2: 523.177
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.853,
  x2: 212.313,
  y2: 330.904
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 302.351,
  y1: 80.835,
  x2: 415.346,
  y2: 384.135
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 498.46,
  y1: 183.629,
  x2: 415.346,
  y2: 384.135
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 302.351,
  y1: 80.835,
  x2: 498.46,
  y2: 183.629
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 493.373,
  y1: 648.196,
  x2: 212.313,
  y2: 330.904
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.853,
  x2: 493.373,
  y2: 648.196
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.833,
  x2: 212.313,
  y2: 330.904
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.853,
  x2: 768.749,
  y2: 504.352
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.833,
  x2: 478.397,
  y2: 546.853
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 768.749,
  y1: 504.352,
  x2: 420.687,
  y2: 384.833
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 498.46,
  y1: 183.629,
  x2: 712.24,
  y2: 612.047
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 683.583,
  y1: 271.532,
  x2: 712.24,
  y2: 612.047
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.833,
  x2: 683.583,
  y2: 271.532
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 958.404,
  y1: 232.804,
  x2: 683.583,
  y2: 271.532
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 712.24,
  y1: 612.047,
  x2: 1077.763,
  y2: 451.118
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 768.749,
  y1: 504.352,
  x2: 958.404,
  y2: 232.804
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 683.583,
  y1: 271.532,
  x2: 1077.763,
  y2: 451.118
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 712.24,
  y1: 612.047,
  x2: 1079.255,
  y2: 255.917
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.396,
  x2: 1079.255,
  y2: 255.917
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 683.583,
  y1: 271.532,
  x2: 951.932,
  y2: 673.781
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1077.763,
  y1: 451.118,
  x2: 951.932,
  y2: 673.781
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.396,
  x2: 1255.718,
  y2: 391.314
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 951.932,
  y1: 673.781,
  x2: 1255.718,
  y2: 391.314
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1077.763,
  y1: 451.118,
  x2: 1255.718,
  y2: 391.314
})), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 151.925,
  y1: 188.578,
  x2: 212.313,
  y2: 330.904
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 498.614,
  y1: 185.769,
  x2: 151.925,
  y2: 188.578
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.833,
  x2: 151.925,
  y2: 188.578
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.396,
  x2: 1263.865,
  y2: 674.139
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1383.401,
  y1: 584.162,
  x2: 1263.865,
  y2: 674.139
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1355.236,
  y1: 424.623,
  x2: 1383.401,
  y2: 584.162
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1355.236,
  y1: 424.623,
  x2: 1255.718,
  y2: 391.314
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1297.243,
  y1: 530.72,
  x2: 1255.718,
  y2: 391.314
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1355.236,
  y1: 424.623,
  x2: 1297.243,
  y2: 530.72
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1383.401,
  y1: 584.162,
  x2: 1297.243,
  y2: 530.72
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1263.862,
  y1: 674.069,
  x2: 1297.243,
  y2: 530.72
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.396,
  x2: 1297.243,
  y2: 530.72
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1334.893,
  y1: 348.394,
  x2: 1297.243,
  y2: 530.72
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1255.718,
  y1: 391.314,
  x2: 1334.893,
  y2: 348.394
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1383.401,
  y1: 584.162,
  x2: 1174.609,
  y2: 584.396
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 94.4826 1129.4214)",
  className: "st11",
  cx: 768.749,
  cy: 504.352,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -454.03 873.7145)",
  className: "st11",
  cx: 331.139,
  cy: 726.905,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -345.6339 604.7517)",
  className: "st11",
  cx: 213.516,
  cy: 523.177,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -789.3422 687.0339)",
  className: "st11",
  cx: 44.226,
  cy: 847.772,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -164.4801 876.8221)",
  className: "st11",
  cx: 477.9,
  cy: 543.486,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6211 -0.7838 0.7838 0.6211 -439.8165 301.7266)",
  className: "st11",
  cx: 92.129,
  cy: 605.709,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 567.4658 1513.324)",
  className: "st11",
  cx: 1250.488,
  cy: 394.148,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -250.1842 966.9956)",
  className: "st11",
  cx: 492.653,
  cy: 643.323,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -403.4831 734.9479)",
  className: "st11",
  cx: 267.765,
  cy: 625.231,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -165.6616 463.8907)",
  className: "st11",
  cx: 213.516,
  cy: 337.775,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -67.4464 296.21)",
  className: "st11",
  cx: 155.504,
  cy: 191.192,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 151.246 354.9114)",
  className: "st11",
  cx: 302.351,
  cy: 80.835,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -59.1 697.9308)",
  className: "st11",
  cx: 416.309,
  cy: 386.72,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 504.1997 1109.1656)",
  className: "st11",
  cx: 960.667,
  cy: 232.485,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 255.779 869.8629)",
  className: "st11",
  cx: 683.583,
  cy: 271.532,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -48.7591 1158.6571)",
  className: "st11",
  cx: 715.804,
  cy: 610.477,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 199.0013 615.4263)",
  className: "st11",
  cx: 492.653,
  cy: 180.585,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 470.4157 1662.4712)",
  className: "st11",
  cx: 1297.243,
  cy: 530.72,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 380.9346 1388.9403)",
  className: "st11",
  cx: 1077.763,
  cy: 451.118,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 617.4665 1638.1578)",
  className: "st11",
  cx: 1355.236,
  cy: 424.623,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 571.5526 1242.0835)",
  className: "st11",
  cx: 1079.255,
  cy: 255.917,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 75.8849 1437.0291)",
  className: "st11",
  cx: 955.959,
  cy: 670.037,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 676.0071 1560.4944)",
  className: "st11",
  cx: 1334.893,
  cy: 348.394,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 483.9976 1786.7086)",
  className: "st11",
  cx: 1383.401,
  cy: 584.162,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 332.5111 1587.8705)",
  className: "st11",
  cx: 1180.634,
  cy: 581.517,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 307.1252 1738.4105)",
  className: "st11",
  cx: 1264.11,
  cy: 673.005,
  rx: 10.403,
  ry: 10.403
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Board"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_2_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M1155.865,691.975c4.339-4.198,7.015-10.057,7.015-16.565v-492.08c0-5.325-1.803-10.198-4.789-14.086 l11.325-9.24c6.48,7.268,10.367,16.537,10.367,26.594v484.389c0.056,11.86-5.353,22.594-14.086,30.285l-10.452-8.733 C1155.443,692.37,1155.668,692.173,1155.865,691.975z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M1169.416,160.004l-11.325,9.24c-4.226-5.409-10.79-8.902-18.199-8.902H394.265 c-5.522,0-10.593,1.944-14.565,5.184l-0.423-0.563l-8.621-8.057c8.452-7.747,20.143-12.537,33.074-12.537h729.513 C1147.864,144.369,1160.88,150.482,1169.416,160.004z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M1155.245,692.539l10.452,8.733c-8.395,7.381-19.833,11.945-32.454,11.945H403.73 c-14.171,0-26.848-5.747-35.384-14.79l9.325-7.043c4.198,4.339,10.086,7.043,16.593,7.043h745.627 C1145.808,698.427,1151.189,696.201,1155.245,692.539z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M377.671,691.384c-3.944-4.141-6.423-9.804-6.423-15.974v-492.08c0-7.184,3.296-13.607,8.452-17.805 c3.972-3.24,9.043-5.184,14.565-5.184h745.627c7.409,0,13.973,3.493,18.199,8.902c2.986,3.888,4.789,8.761,4.789,14.086v492.08 c0,6.508-2.676,12.367-7.015,16.565c-0.197,0.197-0.423,0.394-0.62,0.563c-4.057,3.662-9.438,5.888-15.354,5.888H394.265 C387.757,698.427,381.869,695.722,377.671,691.384z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M379.277,164.963l0.423,0.563c-5.155,4.198-8.452,10.621-8.452,17.805v492.08 c0,6.17,2.479,11.832,6.423,15.974l-9.325,7.043c-6.958-7.381-11.184-16.988-11.184-27.439V186.599 c0-11.579,5.155-22.087,13.494-29.693L379.277,164.963z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M1165.697,701.272c-8.395,7.381-19.833,11.945-32.454,11.945H403.73c-14.171,0-26.848-5.747-35.384-14.79 c-6.958-7.381-11.184-16.988-11.184-27.439V186.599c0-11.579,5.155-22.087,13.494-29.693 c8.452-7.747,20.143-12.537,33.074-12.537h729.513c14.621,0,27.637,6.113,36.173,15.635c6.48,7.268,10.367,16.537,10.367,26.594 v484.389C1179.84,682.848,1174.431,693.581,1165.697,701.272z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M1155.245,692.539c-4.057,3.662-9.438,5.888-15.354,5.888H394.265c-6.508,0-12.396-2.704-16.593-7.043 c-3.944-4.141-6.423-9.804-6.423-15.974v-492.08c0-7.184,3.296-13.607,8.452-17.805c3.972-3.24,9.043-5.184,14.565-5.184 h745.627c7.409,0,13.973,3.493,18.199,8.902c2.986,3.888,4.789,8.761,4.789,14.086v492.08c0,6.508-2.676,12.367-7.015,16.565 C1155.668,692.173,1155.443,692.37,1155.245,692.539z"
})))));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -700.595,
  y: 22,
  className: "st20",
  width: 1990,
  height: 1296
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "st21",
  cx: 627.358,
  cy: 680.304,
  r: 4.439
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_1_",
  filterUnits: "userSpaceOnUse",
  x: 29.473,
  y: 70.172,
  width: 1432.764,
  height: 792.095
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
})));

var _ref8 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 29.473,
  y: 70.172,
  width: 1432.764,
  height: 792.095,
  id: "SVGID_2_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st7"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M1139.072,697.333H394.405c-12.703,0-23-10.297-23-23V183c0-12.703,10.297-23,23-23h744.667 c12.703,0,23,10.297,23,23v491.333C1162.072,687.036,1151.774,697.333,1139.072,697.333z"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 43.244,
  y1: 847.43,
  x2: 91.803,
  y2: 607.062
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 493.373,
  y1: 647.938,
  x2: 91.803,
  y2: 607.062
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 329.71,
  y1: 727.503,
  x2: 43.244,
  y2: 847.43
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 213.516,
  y1: 522.919,
  x2: 329.71,
  y2: 727.503
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.595,
  x2: 213.516,
  y2: 522.919
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 43.244,
  y1: 847.43,
  x2: 267.765,
  y2: 624.973
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 416.981,
  y1: 384.582,
  x2: 213.516,
  y2: 522.919
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.595,
  x2: 212.313,
  y2: 330.646
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 302.351,
  y1: 80.578,
  x2: 415.346,
  y2: 383.878
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 498.46,
  y1: 183.371,
  x2: 415.346,
  y2: 383.878
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 302.351,
  y1: 80.578,
  x2: 498.46,
  y2: 183.371
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 493.373,
  y1: 647.938,
  x2: 212.313,
  y2: 330.646
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.595,
  x2: 493.373,
  y2: 647.938
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.576,
  x2: 212.313,
  y2: 330.646
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 478.397,
  y1: 546.595,
  x2: 768.749,
  y2: 504.095
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.576,
  x2: 478.397,
  y2: 546.595
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 768.749,
  y1: 504.095,
  x2: 420.687,
  y2: 384.576
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 498.46,
  y1: 183.371,
  x2: 712.24,
  y2: 611.789
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 683.583,
  y1: 271.275,
  x2: 712.24,
  y2: 611.789
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.576,
  x2: 683.583,
  y2: 271.275
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 958.404,
  y1: 232.546,
  x2: 683.583,
  y2: 271.275
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 712.24,
  y1: 611.789,
  x2: 1077.763,
  y2: 450.86
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 768.749,
  y1: 504.095,
  x2: 958.404,
  y2: 232.546
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 683.583,
  y1: 271.275,
  x2: 1077.763,
  y2: 450.86
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 712.24,
  y1: 611.789,
  x2: 1079.255,
  y2: 255.659
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.139,
  x2: 1079.255,
  y2: 255.659
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 683.583,
  y1: 271.275,
  x2: 951.932,
  y2: 673.523
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1077.763,
  y1: 450.86,
  x2: 951.932,
  y2: 673.523
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.139,
  x2: 1255.718,
  y2: 391.056
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 951.932,
  y1: 673.523,
  x2: 1255.718,
  y2: 391.056
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1077.763,
  y1: 450.86,
  x2: 1255.718,
  y2: 391.056
})), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 151.925,
  y1: 188.32,
  x2: 212.313,
  y2: 330.646
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 498.614,
  y1: 185.511,
  x2: 151.925,
  y2: 188.32
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 420.687,
  y1: 384.576,
  x2: 151.925,
  y2: 188.32
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.139,
  x2: 1240.083,
  y2: 649.969
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1378.234,
  y1: 584.926,
  x2: 1240.083,
  y2: 649.969
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1370.857,
  y1: 443.322,
  x2: 1378.234,
  y2: 584.926
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1370.857,
  y1: 443.322,
  x2: 1255.718,
  y2: 391.056
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1301.782,
  y1: 545.985,
  x2: 1255.718,
  y2: 391.056
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1370.857,
  y1: 443.322,
  x2: 1301.782,
  y2: 545.985
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1378.234,
  y1: 584.926,
  x2: 1301.782,
  y2: 545.985
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1240.083,
  y1: 649.969,
  x2: 1301.782,
  y2: 545.985
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1174.609,
  y1: 584.139,
  x2: 1301.782,
  y2: 545.985
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1334.893,
  y1: 348.136,
  x2: 1301.782,
  y2: 545.985
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1255.718,
  y1: 391.056,
  x2: 1334.893,
  y2: 348.136
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 1378.234,
  y1: 584.926,
  x2: 1174.609,
  y2: 584.139
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 94.7329 1129.2256)",
  className: "st24",
  cx: 768.749,
  cy: 504.095,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -454.9792 873.1833)",
  className: "st24",
  cx: 330.325,
  cy: 727.246,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -345.3836 604.5558)",
  className: "st24",
  cx: 213.516,
  cy: 522.919,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -789.092 686.838)",
  className: "st24",
  cx: 44.226,
  cy: 847.514,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -164.2299 876.6262)",
  className: "st24",
  cx: 477.9,
  cy: 543.228,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6211 -0.7838 0.7838 0.6211 -439.6145 301.6289)",
  className: "st24",
  cx: 92.129,
  cy: 605.451,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 567.716 1513.1281)",
  className: "st24",
  cx: 1250.488,
  cy: 393.89,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -249.9339 966.7997)",
  className: "st24",
  cx: 492.653,
  cy: 643.065,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -403.2328 734.752)",
  className: "st24",
  cx: 267.765,
  cy: 624.973,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -165.4113 463.6948)",
  className: "st24",
  cx: 213.516,
  cy: 337.517,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -67.1961 296.0142)",
  className: "st24",
  cx: 155.504,
  cy: 190.934,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 151.4963 354.7156)",
  className: "st24",
  cx: 302.351,
  cy: 80.578,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -58.8497 697.7349)",
  className: "st24",
  cx: 416.309,
  cy: 386.462,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 504.45 1108.9698)",
  className: "st24",
  cx: 960.667,
  cy: 232.228,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 256.0293 869.6671)",
  className: "st24",
  cx: 683.583,
  cy: 271.275,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 -48.5088 1158.4612)",
  className: "st24",
  cx: 715.804,
  cy: 610.219,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 199.2515 615.2305)",
  className: "st24",
  cx: 492.653,
  cy: 180.328,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 495.351 1746.6396)",
  className: "st24",
  cx: 1363.48,
  cy: 556.875,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 381.1849 1388.7444)",
  className: "st24",
  cx: 1077.763,
  cy: 450.86,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 571.8029 1241.8876)",
  className: "st24",
  cx: 1079.255,
  cy: 255.659,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 76.1352 1436.8333)",
  className: "st24",
  cx: 955.959,
  cy: 669.779,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 676.2573 1560.2986)",
  className: "st24",
  cx: 1334.893,
  cy: 348.136,
  rx: 10.403,
  ry: 10.403
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 332.7613 1587.6747)",
  className: "st24",
  cx: 1180.634,
  cy: 581.26,
  rx: 14.75,
  ry: 14.75
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2402 -0.9707 0.9707 0.2402 312.2714 1703.5118)",
  className: "st24",
  cx: 1244.389,
  cy: 652.268,
  rx: 10.403,
  ry: 10.403
}));

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "st21",
  cx: 729.329,
  cy: 231.459,
  r: 6.943
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
}, /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M718.64,459.086H498.025c-5.938,0-10.688-4.82-10.688-10.688V328.589c0-5.938,4.82-10.688,10.688-10.688 H718.64c5.938,0,10.688,4.82,10.688,10.688v119.808C729.329,454.265,724.578,459.086,718.64,459.086z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st26",
  cx: 571.503,
  cy: 241.24,
  r: 9.78
}), /*#__PURE__*/React.createElement("circle", {
  className: "st26",
  cx: 641.577,
  cy: 603.873,
  r: 9.78
}), /*#__PURE__*/React.createElement("circle", {
  className: "st26",
  cx: 598.396,
  cy: 217.474,
  r: 17.465
}), /*#__PURE__*/React.createElement("circle", {
  className: "st27",
  cx: 1034.403,
  cy: 173.686,
  r: 4.192
}), /*#__PURE__*/React.createElement("circle", {
  className: "st27",
  cx: 889.481,
  cy: 458.476,
  r: 4.192
}), /*#__PURE__*/React.createElement("circle", {
  className: "st27",
  cx: 975.442,
  cy: 640.107,
  r: 4.192
}), /*#__PURE__*/React.createElement("circle", {
  className: "st28",
  cx: 853.224,
  cy: 680.304,
  r: 4.192
}), /*#__PURE__*/React.createElement("circle", {
  className: "st28",
  cx: 1061.16,
  cy: 259.403,
  r: 4.192
}), /*#__PURE__*/React.createElement("circle", {
  className: "st28",
  cx: 882.146,
  cy: 454.913,
  r: 4.192
}), /*#__PURE__*/React.createElement("circle", {
  className: "st28",
  cx: 654.44,
  cy: 620.924,
  r: 4.192
}), /*#__PURE__*/React.createElement("circle", {
  className: "st28",
  cx: 541.854,
  cy: 600.62,
  r: 4.192
}), /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M885.813,345.33c-4.261,0-7.685-3.423-7.685-7.685s3.423-7.685,7.685-7.685 c4.261,0,7.685,3.423,7.685,7.685l0,0C893.498,341.907,890.074,345.33,885.813,345.33z M885.813,331.358 c-3.493,0-6.287,2.794-6.287,6.287s2.794,6.287,6.287,6.287c3.493,0,6.287-2.794,6.287-6.287S889.306,331.358,885.813,331.358z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M1016.194,238.655c-4.261,0-7.684-3.423-7.684-7.685s3.423-7.684,7.684-7.684 c4.261,0,7.685,3.423,7.685,7.684l0,0C1023.878,235.162,1020.455,238.655,1016.194,238.655z M1016.194,224.683 c-3.493,0-6.287,2.794-6.287,6.287c0,3.493,2.794,6.287,6.287,6.287c3.493,0,6.287-2.794,6.287-6.287l0,0 C1022.481,227.477,1019.687,224.683,1016.194,224.683z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M820.321,644.762c-2.492,0-4.983-0.078-7.397-0.078l0.078-1.791c3.504,0.078,7.085,0.156,10.589,0.078 v1.791C822.501,644.762,821.411,644.762,820.321,644.762z M834.336,644.372l-0.078-1.791c3.504-0.234,7.085-0.467,10.589-0.856 l0.156,1.791C841.422,643.827,837.84,644.139,834.336,644.372z M802.257,644.061c-3.504-0.234-7.085-0.623-10.667-1.09 l0.234-1.791c3.504,0.389,7.008,0.779,10.589,1.012L802.257,644.061z M855.593,642.114l-0.234-1.791 c3.504-0.545,7.008-1.168,10.434-1.791l0.312,1.713C862.6,640.946,859.097,641.569,855.593,642.114z M781.079,641.492 c-3.504-0.623-7.008-1.246-10.511-2.024l0.389-1.713c3.426,0.779,6.93,1.402,10.434,2.024L781.079,641.492z M876.538,637.988 l-0.389-1.713c3.426-0.857,6.852-1.791,10.2-2.803l0.467,1.713C883.39,636.197,879.964,637.131,876.538,637.988z  M760.212,636.976c-3.426-0.934-6.852-1.947-10.278-2.959l0.545-1.713c3.348,1.09,6.774,2.024,10.2,2.959L760.212,636.976z  M897.016,631.914l-0.545-1.713c3.348-1.168,6.696-2.414,9.966-3.737l0.623,1.635 C903.712,629.501,900.364,630.747,897.016,631.914z M739.812,630.513c-3.348-1.246-6.696-2.569-9.966-3.893l0.701-1.635 c3.27,1.401,6.618,2.647,9.888,3.893L739.812,630.513z M916.793,623.973l-0.701-1.635c3.192-1.479,6.385-2.959,9.499-4.594 l0.779,1.557C923.255,620.936,919.985,622.493,916.793,623.973z M720.035,622.182c-3.192-1.557-6.385-3.115-9.577-4.827 l0.857-1.557c3.115,1.635,6.307,3.27,9.499,4.75L720.035,622.182z M935.791,614.24l-0.857-1.557 c3.037-1.713,6.151-3.582,9.11-5.45l0.934,1.479C941.942,610.658,938.905,612.527,935.791,614.24L935.791,614.24z  M701.192,612.137c-3.037-1.791-6.073-3.737-9.032-5.684l1.012-1.479c2.959,1.947,5.995,3.815,9.032,5.606L701.192,612.137z  M953.855,602.872l-1.012-1.479c2.881-2.024,5.762-4.127,8.565-6.229l1.09,1.401 C959.617,598.667,956.736,600.847,953.855,602.872L953.855,602.872z M683.362,600.38c-2.881-2.102-5.762-4.282-8.487-6.463 l1.09-1.401c2.725,2.18,5.606,4.36,8.409,6.463L683.362,600.38z M970.751,589.869l-1.168-1.324 c2.647-2.258,5.372-4.594,7.942-7.008l1.168,1.324C976.124,585.197,973.476,587.533,970.751,589.869z M666.621,586.988 c-2.647-2.336-5.295-4.75-7.864-7.241l1.246-1.246c2.569,2.414,5.139,4.828,7.786,7.163L666.621,586.988z M986.401,575.309 l-1.246-1.246c2.492-2.492,4.905-5.139,7.241-7.708l1.324,1.168C991.385,570.17,988.893,572.817,986.401,575.309L986.401,575.309 z M651.204,572.194c-2.414-2.569-4.827-5.217-7.163-7.942l1.324-1.168c2.336,2.647,4.672,5.295,7.163,7.864L651.204,572.194z  M1000.728,559.425l-1.402-1.09c2.258-2.725,4.438-5.528,6.54-8.331l1.402,1.09 C1005.244,553.896,1002.986,556.7,1000.728,559.425L1000.728,559.425z M637.189,556.077c-2.18-2.803-4.36-5.606-6.463-8.487 l1.402-1.012c2.024,2.881,4.205,5.684,6.385,8.487L637.189,556.077z M1013.575,542.373l-1.479-1.012 c1.947-2.881,3.893-5.918,5.762-8.954l1.479,0.934C1017.468,536.378,1015.522,539.414,1013.575,542.373L1013.575,542.373z  M624.731,538.791c-1.947-2.959-3.815-5.995-5.606-9.032l1.557-0.934c1.791,3.037,3.66,6.073,5.606,9.032L624.731,538.791z  M1024.71,524.153l-1.557-0.857c1.713-3.115,3.348-6.229,4.905-9.421l1.557,0.779 C1028.135,517.846,1026.423,521.039,1024.71,524.153z M613.908,520.416c-1.635-3.114-3.27-6.307-4.75-9.577l1.635-0.779 c1.479,3.192,3.115,6.385,4.75,9.499L613.908,520.416z M1034.209,504.921l-1.635-0.701c1.402-3.192,2.803-6.54,4.049-9.811 l1.635,0.623C1037.012,498.303,1035.61,501.651,1034.209,504.921z M604.799,501.106c-1.324-3.27-2.647-6.618-3.893-9.966 l1.635-0.623c1.168,3.27,2.492,6.618,3.815,9.889L604.799,501.106z M1041.917,484.911l-1.713-0.545 c1.09-3.348,2.18-6.774,3.114-10.122l1.713,0.467C1044.019,478.137,1043.007,481.562,1041.917,484.911z M597.557,481.017 c-1.09-3.348-2.024-6.852-2.959-10.278l1.713-0.467c0.856,3.426,1.869,6.852,2.959,10.2L597.557,481.017z M1047.679,464.355 l-1.713-0.389c0.779-3.426,1.557-6.93,2.18-10.356l1.713,0.311C1049.236,457.425,1048.458,460.929,1047.679,464.355 L1047.679,464.355z M592.107,460.384c-0.779-3.504-1.401-7.008-2.024-10.511l1.713-0.311c0.545,3.504,1.246,7.008,1.947,10.434 L592.107,460.384z M1051.572,443.332l-1.791-0.234c0.467-3.504,0.856-7.008,1.168-10.511l1.791,0.156 C1052.429,436.324,1052.039,439.828,1051.572,443.332L1051.572,443.332z M588.603,439.283c-0.389-3.504-0.779-7.085-1.012-10.667 l1.791-0.156c0.234,3.504,0.623,7.085,1.012,10.589L588.603,439.283z M1053.441,422.076l-1.791-0.078 c0.156-3.504,0.234-7.085,0.234-10.589h1.791C1053.674,414.912,1053.597,418.572,1053.441,422.076L1053.441,422.076z  M587.046,418.027c-0.078-2.18-0.078-4.36-0.078-6.618c0-1.401,0-2.725,0-4.127h1.791c0,1.324,0,2.725,0,4.049 c0,2.18,0,4.36,0.078,6.54L587.046,418.027z M1051.884,408.917c0-3.504-0.156-7.085-0.312-10.589l1.791-0.078 c0.234,3.504,0.312,7.163,0.389,10.667H1051.884z M589.226,396.77l-1.791-0.078c0.234-3.582,0.545-7.163,0.934-10.667 l1.791,0.156C589.693,389.685,589.382,393.267,589.226,396.77z M1050.716,387.738c-0.389-3.504-0.779-7.008-1.324-10.511 l1.791-0.234c0.545,3.504,0.934,7.085,1.324,10.589L1050.716,387.738z M591.484,375.67l-1.791-0.234 c0.545-3.504,1.168-7.085,1.869-10.511l1.713,0.389C592.652,368.662,592.029,372.166,591.484,375.67z M1047.601,366.794 c-0.701-3.426-1.401-6.93-2.258-10.356l1.713-0.389c0.856,3.426,1.635,6.93,2.258,10.434L1047.601,366.794z M595.689,354.881 l-1.713-0.467c0.856-3.426,1.791-6.93,2.803-10.278l1.713,0.545C597.479,348.029,596.545,351.455,595.689,354.881z  M1042.618,346.16c-1.012-3.348-2.102-6.774-3.192-10.122l1.713-0.545c1.168,3.348,2.258,6.774,3.27,10.2L1042.618,346.16z  M601.762,334.559l-1.713-0.623c1.168-3.348,2.492-6.696,3.815-10.044l1.635,0.701 C604.253,327.862,602.93,331.21,601.762,334.559z M1035.766,326.149c-1.324-3.27-2.647-6.54-4.127-9.733l1.635-0.701 c1.479,3.192,2.881,6.54,4.127,9.811L1035.766,326.149z M609.782,314.859l-1.635-0.779c1.479-3.192,3.037-6.463,4.672-9.655 l1.557,0.779C612.818,308.475,611.261,311.667,609.782,314.859z M1027.045,306.84c-1.557-3.115-3.27-6.307-4.983-9.343 l1.557-0.857c1.713,3.115,3.426,6.229,5.061,9.421L1027.045,306.84z M619.514,296.017l-1.557-0.857 c1.791-3.037,3.66-6.151,5.528-9.11l1.479,0.934C623.096,289.866,621.227,292.98,619.514,296.017L619.514,296.017z  M1016.612,288.464c-1.869-2.959-3.815-5.995-5.84-8.876l1.479-1.012c2.024,2.881,3.971,5.918,5.918,8.876L1016.612,288.464z  M630.96,278.108l-1.479-1.012c2.024-2.881,4.205-5.762,6.385-8.565l1.401,1.09C635.087,272.347,632.985,275.228,630.96,278.108z  M1004.543,271.023c-2.102-2.803-4.36-5.606-6.618-8.253l1.324-1.168c2.258,2.725,4.516,5.528,6.696,8.331L1004.543,271.023z  M643.963,261.368l-1.324-1.168c2.258-2.725,4.672-5.372,7.085-7.942l1.324,1.246 C648.557,255.996,646.221,258.643,643.963,261.368z M990.917,254.75c-2.414-2.569-4.827-5.139-7.319-7.63l1.246-1.246 c2.492,2.492,4.983,5.061,7.397,7.708L990.917,254.75z M658.368,245.873l-1.246-1.246c2.569-2.492,5.139-4.905,7.786-7.319 l1.168,1.324C663.507,240.968,660.937,243.382,658.368,245.873L658.368,245.873z M975.89,239.8 c-2.647-2.336-5.295-4.672-8.02-6.93l1.168-1.402c2.725,2.258,5.45,4.594,8.098,7.008L975.89,239.8z M674.174,231.703 l-1.09-1.402c2.725-2.258,5.606-4.438,8.409-6.54l1.09,1.402C679.78,227.342,676.899,229.522,674.174,231.703z M959.539,226.33 c-2.803-2.102-5.684-4.205-8.643-6.229l1.012-1.479c2.959,2.024,5.84,4.127,8.721,6.229L959.539,226.33z M691.226,219.089 l-1.012-1.479c2.959-1.947,5.995-3.893,8.954-5.762l0.934,1.479C697.143,215.196,694.107,217.142,691.226,219.089z  M942.02,214.339c-3.037-1.869-6.073-3.66-9.188-5.372l0.856-1.557c3.115,1.713,6.229,3.582,9.188,5.45L942.02,214.339z  M709.29,208.11l-0.856-1.557c3.115-1.713,6.307-3.348,9.499-4.905l0.779,1.557C715.596,204.762,712.404,206.397,709.29,208.11 L709.29,208.11z M923.489,203.984c-3.192-1.557-6.385-3.114-9.577-4.516l0.701-1.635c3.27,1.402,6.54,2.959,9.655,4.516 L923.489,203.984z M728.288,198.845l-0.701-1.635c3.27-1.402,6.54-2.725,9.888-4.049l0.623,1.635 C734.828,196.042,731.558,197.443,728.288,198.845z M904.101,195.419c-3.27-1.246-6.618-2.492-9.966-3.582l0.545-1.713 c3.348,1.168,6.774,2.336,10.044,3.66L904.101,195.419z M748.143,191.292l-0.545-1.713c3.348-1.09,6.852-2.18,10.2-3.115 l0.467,1.713C754.917,189.19,751.491,190.202,748.143,191.292z M883.935,188.645c-3.348-0.934-6.852-1.869-10.278-2.647 l0.389-1.713c3.426,0.779,6.93,1.713,10.356,2.725L883.935,188.645z M768.543,185.608l-0.389-1.713 c3.426-0.779,7.008-1.479,10.434-2.102l0.311,1.713C775.473,184.129,771.969,184.829,768.543,185.608L768.543,185.608z  M863.301,183.817c-3.426-0.623-7.008-1.246-10.434-1.713l0.234-1.791c3.504,0.467,7.085,1.09,10.511,1.713L863.301,183.817z  M789.41,181.871l-0.234-1.791c3.504-0.467,7.085-0.856,10.589-1.168l0.156,1.791 C796.417,181.014,792.914,181.404,789.41,181.871L789.41,181.871z M842.278,180.858c-3.504-0.311-7.085-0.545-10.589-0.779 l0.078-1.791c3.582,0.156,7.163,0.389,10.667,0.779L842.278,180.858z M810.511,180.002l-0.078-1.791 c3.27-0.156,6.618-0.234,9.888-0.234h0.779v1.791h-0.779C817.051,179.846,813.781,179.846,810.511,180.002L810.511,180.002z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M952.319,609.702H771.314c-5.868,0-10.688-4.75-10.688-10.688v-74.121c0-5.868,4.75-10.688,10.688-10.688 h181.005c5.868,0,10.688,4.75,10.688,10.688v74.121C963.007,604.882,958.187,609.702,952.319,609.702z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M1087.217,398.797H940.932c-5.938,0-10.688-4.82-10.688-10.688V308.12c0-5.938,4.82-10.688,10.688-10.688 h146.285c5.938,0,10.688,4.82,10.688,10.688v79.989C1097.905,393.977,1093.155,398.797,1087.217,398.797z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M1078.624,390.414H932.06c-5.938,0-10.688-4.82-10.688-10.688v-80.687c0-5.938,4.82-10.688,10.688-10.688 h146.564c5.938,0,10.689,4.82,10.689,10.688v80.617C1089.383,385.594,1084.562,390.414,1078.624,390.414z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M943.587,600.62H762.861c-5.868,0-10.688-4.75-10.688-10.688v-74.121c0-5.868,4.75-10.688,10.688-10.688 h180.726c5.868,0,10.688,4.75,10.688,10.688v74.121C954.205,595.87,949.455,600.62,943.587,600.62z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M709.489,450.982H488.873c-5.868,0-10.688-4.75-10.688-10.688V320.485c0-5.868,4.75-10.688,10.688-10.688 h220.615c5.868,0,10.688,4.75,10.688,10.688v119.808C720.177,446.232,715.427,450.982,709.489,450.982z"
}));

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  className: "st21",
  cx: 746.479,
  cy: 217.474,
  r: 10.207
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "st21",
  cx: 1010.408,
  cy: 659.975,
  r: 4.439
});

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M649.063,422.27H545.927c-2.703,0-4.902-2.207-4.902-4.919v-69.549c0-2.712,2.199-4.919,4.902-4.919 h103.135c2.706,0,4.909,2.207,4.909,4.919v69.549C653.972,420.063,651.769,422.27,649.063,422.27z M545.927,344.74 c-1.679,0-3.045,1.373-3.045,3.062v69.549c0,1.688,1.366,3.062,3.045,3.062h103.135c1.683,0,3.052-1.373,3.052-3.062v-69.549 c0-1.688-1.369-3.062-3.052-3.062H545.927z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M653.044,358.943h-111.09c-0.513,0-0.928-0.415-0.928-0.929s0.415-0.929,0.928-0.929h111.09 c0.513,0,0.929,0.415,0.929,0.929S653.557,358.943,653.044,358.943z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M552.507,354.781h-5.879c-0.513,0-0.929-0.415-0.929-0.929v-5.88c0-0.513,0.415-0.929,0.929-0.929h5.879 c0.513,0,0.929,0.415,0.929,0.929v5.88C553.436,354.366,553.02,354.781,552.507,354.781z M547.556,352.924h4.022v-4.022h-4.022 V352.924z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M563.936,354.781h-5.873c-0.513,0-0.928-0.415-0.928-0.929v-5.88c0-0.513,0.415-0.929,0.928-0.929h5.873 c0.513,0,0.929,0.415,0.929,0.929v5.88C564.864,354.366,564.449,354.781,563.936,354.781z M558.992,352.924h4.015v-4.022h-4.015 V352.924z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M575.366,354.781h-5.875c-0.513,0-0.929-0.415-0.929-0.929v-5.88c0-0.513,0.415-0.929,0.929-0.929h5.875 c0.513,0,0.929,0.415,0.929,0.929v5.88C576.294,354.366,575.879,354.781,575.366,354.781z M570.419,352.924h4.018v-4.022h-4.018 V352.924z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M583.153,409.452c-0.209,0-0.42-0.071-0.594-0.215l-23.298-19.373c-0.212-0.177-0.335-0.438-0.335-0.714 c0-0.276,0.123-0.537,0.335-0.714l22.047-18.336c0.396-0.326,0.98-0.273,1.308,0.12c0.328,0.395,0.273,0.98-0.12,1.308 l-21.19,17.622l22.44,18.659c0.393,0.328,0.448,0.913,0.12,1.308C583.682,409.338,583.419,409.452,583.153,409.452z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M611.841,409.452c-0.266,0-0.53-0.114-0.714-0.335c-0.328-0.395-0.273-0.98,0.12-1.308l22.431-18.659 l-21.183-17.622c-0.393-0.328-0.447-0.913-0.12-1.308c0.329-0.393,0.912-0.446,1.308-0.12l22.04,18.336 c0.212,0.177,0.335,0.438,0.335,0.714c0,0.276-0.123,0.537-0.335,0.714l-23.288,19.373 C612.26,409.381,612.05,409.452,611.841,409.452z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M589.441,408.855c-0.108,0-0.219-0.025-0.321-0.077c-0.356-0.178-0.5-0.611-0.321-0.966l17.909-35.716 c0.177-0.355,0.611-0.502,0.966-0.321c0.356,0.179,0.5,0.611,0.321,0.966l-17.909,35.716 C589.959,408.709,589.705,408.855,589.441,408.855z"
}))));

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M1004.993,368.925c1.481,9.982-21.687,10.287-23.648-4.81c-9.529,2.67-16.113-6.53-11.504-14.662 c-5.527-3.772-5.425-14.776,0.334-18.074c-4.401-4.689,0.938-17.821,11.582-15.478c-2.906-10.548,12.483-19.142,23.298-10.736 L1004.993,368.925z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M981.431,313.56c0.791,4.68,4.911,8.304,9.612,9.148"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M991.043,310.043c-1.087,6.992,10.647,9.927,13.835,5.391"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M985.18,320.361c-0.019,2.454-3.302,5.598-5.157,6.331"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M977.915,334.663c2.89,1.462,2.955,5.668,6.085,6.601c3.281,0.976,5.065-2.648,6.383-5.164 c2.008-3.836,4.99-5.391,9.334-4.707c1.416,0.222,3.874,1.216,4.692,1.628"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M974.63,334.428c2.246,2.787,5.852-1.33,3.518-3.75"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M1005.112,348.967c-3.079-3.07-7.874,0.394-8.907,3.719c-1.218,3.913,2.485,7.103,1.182,10.915 c-0.79,2.315-2.606,3.335-4.937,2.949"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M981.431,366.08c-3.615-9.459,14.303-6.795,6.564-21.101"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M969.705,349.903c1.284-2.1,4.351-2.257,6.584-2.118c2.019,0.126,4.288,1.647,5.142,1.884"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M1051.649,344.983l0.337-10.315l-6.255-0.207c-0.379-2.143-0.971-4.212-1.755-6.179l5.736-3.144 l-4.966-9.052l-6.1,3.343c-1.314-1.542-2.774-2.962-4.357-4.23l3.643-6.158l-8.883-5.259l-3.759,6.352 c-1.823-0.662-3.728-1.161-5.691-1.484V301.2h-5.1V376h5.1v-4.621c1.943-0.317,3.829-0.807,5.636-1.463l2.198,4.132l9.114-4.84 l-2.304-4.338c1.702-1.361,3.268-2.889,4.659-4.563l4.304,2.743l5.549-8.707l-4.637-2.953c0.807-2.1,1.403-4.308,1.749-6.599 L1051.649,344.983z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M1014.498,316.035v7.115c8.505,0.035,15.39,6.934,15.39,15.45c0,8.514-6.885,15.419-15.39,15.447v7.116 c12.433-0.034,22.504-10.121,22.504-22.563S1026.931,316.069,1014.498,316.035z"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st34",
  d: "M901.702,571.147c0,2.562-2.075,4.637-4.634,4.637h-79.306c-2.56,0-4.635-2.075-4.635-4.637v-50.322 c0-2.561,2.076-4.639,4.635-4.639h79.306c2.559,0,4.634,2.078,4.634,4.639V571.147z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 849.044,
  y: 575.784,
  className: "st34",
  width: 16.741,
  height: 12.55
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M871.297,588.334h-5.695h-8.187h-8.184h-5.695c0,0-3.613,0-3.992,4.018h17.871h17.873 C874.909,588.334,871.297,588.334,871.297,588.334z"
})), /*#__PURE__*/React.createElement("polyline", {
  className: "st34",
  points: "821.045,544.732 821.045,568.837 842.469,568.837  "
}));

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st34",
  d: "M851.963,558.642v5.274h17.736v-11.28c7.98-9.754,4.37-19.621,4.37-19.621 c-4.206-12.312-22.095-6.749-22.095-6.749s-6.802,1.126-7.162,9.183c0,0-0.357,3.403-1.61,5.371l-3.223,4.836 c0,0-0.896,1.431,2.865,1.969c0,0,1.312,0.298,1.253,1.491v6.088c0,0-1.074,4.148,3.849,4.178l9.847-1.91 c0,0,2.238-0.538,2.417-3.222"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_5"
});

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "Guy"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_4",
  className: "st43"
}, /*#__PURE__*/React.createElement("rect", {
  x: -644.595,
  y: 73,
  className: "st44",
  width: 1486.6,
  height: 1142
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "a12144e9-3c86-4872-a88a-b0ed4a062895_4_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "392.649,776.232 386.639,794.67 404.857,796.339 403.362,776.288  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "479.418,783.629 479.286,808.871 500.226,808.98 494.444,783.708  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M407.447,606.864l-8.975,79.99c0,0-11.081,70.47-8.983,81.563c2.099,11.093-0.623,12.652-0.623,12.652 l16.07,0.084c0,0-0.521-6.843,2.696-9.973s1.666-12.647,1.666-12.647l41.334-121.96l22.669,68.526 c0,0,3.364,75.266,3.914,76.363c0.551,1.097,2.077,15.266,2.077,15.266l19.826,0.104c0,0-2.6-8.428,1.101-11.076 c3.701-2.648,6.959-0.511,3.784-5.248c-3.175-4.737-4.258-10.557-3.131-13.151c1.057-2.594,1.112-13.128,1.112-13.128 s-0.858-142.087-9.946-146.923C482.951,602.469,407.447,606.864,407.447,606.864z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M486.496,802.854c0,0-6.179-1.746-6.182-1.268c-0.003,0.479-5.914,14.246,5.079,13.893 c10.994-0.421,22.157-0.304,19.431-11.126c-2.726-10.823-9.984-4.746-9.984-4.746l2.05,0.372L486.496,802.854z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M398.376,793.022c0,0,7.828-1.327,7.826-0.849c-0.003,0.479,8.474,22.844-0.885,22.385 c-9.359-0.528-28.817,2.434-26.449-8.362c1.282-5.848,2.224-7.768,2.819-8.299l5.946-7.117l0.689-0.957L398.376,793.022z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.0052 -1 1 0.0052 14.0081 886.1034)",
  className: "st4",
  cx: 452.376,
  cy: 436.011,
  rx: 20.727,
  ry: 21.079
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M435.624,433.324c0,0-3.949,36.851-8.763,39.425c-4.814,2.574,36.912,5.46,36.912,5.46 s-9.981-33.709-6.764-36.907C460.225,438.173,435.624,433.324,435.624,433.324z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st45",
  d: "M478.42,590.885c-0.78,2.732-1.489,5.328-2.197,7.719c-3.483,0.871-9.459-0.391-15.709-2.476l1.409-16.752 C469.076,581.738,475.944,585.399,478.42,590.885z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M476.179,433.809c0.558-0.202,1.046-0.542,1.535-0.881c1.188-1.088,0.989-2.936,0.51-4.444 c-0.479-1.507-1.236-3.085-0.88-4.588c0.143-0.683,0.564-1.365,0.707-2.117c0.287-1.709-1.096-3.289-2.691-4.187 c-1.526-0.829-3.332-1.317-4.788-2.282c-2.218-1.517-3.457-4.191-5.744-5.708c-2.219-1.448-5.07-1.531-7.714-1.545l-7.931-0.041 c-4.174-0.022-8.696,0.091-11.841,2.811c-0.978,0.816-1.679,1.838-2.657,2.654c-1.956,1.632-4.534,2.302-6.628,3.659 c-3.211,2.104-5.178,5.651-5.128,9.482c0.051,3.489,1.773,6.85,1.268,10.268c-0.29,2.324-1.624,4.506-1.288,6.834 c0.403,2.738,2.897,4.735,5.536,5.707c2.638,1.04,5.489,1.397,7.987,2.573c2.082,0.969,4.231,2.485,6.391,1.812 c1.881-0.537,2.865-2.448,3.57-4.291c0.776-2.117,1.344-4.234,1.703-6.421c0.287-1.64,0.435-3.418,1.486-4.712 c1.19-1.499,3.073-2.31,4.95-2.095c4.311,0.365,6.639,7.628,10.613,5.938c1.952-0.811,3.496-3.334,5.033-4.694 C471.993,436.113,474.017,434.824,476.179,433.809z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st45",
  d: "M476.346,590.874c-0.78,2.732-1.489,5.328-2.197,7.719c-3.483,0.871-9.459-0.391-15.709-2.476 l1.409-16.753C467.002,581.727,473.87,585.388,476.346,590.874z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M480.432,471.935c0,0-14.882-14.306-32.079-11.728c-17.197,2.578-29.457,5.661-29.457,5.661 s-26.298,13.544-26.912,24.623s9.325,52.654,9.325,52.654s4.445,67.952,5.002,67.955c0.556,0.003,90.441-0.554,90.441-0.554 l-16.164-88.535L480.432,471.935z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M475.186,598.598c-3.483,0.871-9.459-0.391-15.709-2.476c-11.112-3.684-23.046-9.697-23.046-9.697 s-38.46-15.456-49.688-23.45c-11.229-7.926-3.55-39.49-3.55-39.49l17.086,5.357l-1.145,19.49l42.156,27.036 c6.675,0.651,13.207,1.984,19.528,4.001c7.084,2.363,14.022,5.956,16.497,11.51c0.413,0.823,0.687,1.714,0.821,2.672 C478.676,596.427,477.485,597.994,475.186,598.598z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st46",
  d: "M477.383,590.879c-0.78,2.732-1.489,5.328-2.197,7.719c-3.483,0.871-9.459-0.391-15.709-2.476 l1.409-16.753C468.039,581.732,474.907,585.394,477.383,590.879z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M471.099,514.025l-3.346,27.893l-5.716,68.788c0,0-29.678,34.733-13.057,35.846 s25.848-34.069,25.848-34.069s16.918-55.732,16.422-67.296c-0.496-11.563,0.162-31.056,0.162-31.056L471.099,514.025z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M472.733,466.435c0,0,16.284,0.277,18.834,18.213c1.607,12.048,2.448,24.161,2.454,36.337 c0,0-18.182-8.509-26.226-0.137L472.733,466.435z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M401.133,477.368c0,0-13.455,12.005-17.775,26.69c-4.39,14.685-2.773,24.749-2.773,24.749l22.45,3.811 L401.133,477.368z"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "a12144e9-3c86-4872-a88a-b0ed4a062895_1_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "385.408,775.138 379.46,793.876 397.792,795.472 396.183,775.138  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st47",
  points: "474.198,789.573 474.198,811.993 495.259,811.993 489.312,789.573  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M399.401,603.238l-8.606,81.197c0,0-10.775,71.55-8.606,82.793c2.169,11.243-0.56,12.839-0.56,12.839 h16.163c0,0-0.56-6.94,2.659-10.132s1.609-12.839,1.609-12.839l40.932-123.946l23.16,69.399c0,0,3.778,76.339,4.338,77.449 c0.56,1.11,1.638,10.352,1.638,10.352l19.633-1.399c0,0-1.82-2.013,1.889-4.719c3.708-2.707,6.997-0.555,3.778-5.344 c-3.219-4.789-4.338-10.687-3.219-13.325c1.05-2.637,1.05-13.325,1.05-13.325s-1.609-144.141-10.775-148.999 C475.318,598.38,399.401,603.238,399.401,603.238z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st48",
  d: "M479.936,797.858c0,0-6.224-2.253-6.224-1.623s-9.997,18.675,1.059,18.135 c11.055-0.629,30.151,3.527,27.352-10.678c-2.799-14.205-13.811-10.159-13.811-10.159l3.519,0.19L479.936,797.858z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M391.256,792.141c0,0,7.866-1.388,7.866-0.902s8.643,23.13-0.773,22.714 c-9.416-0.486-28.97,2.622-26.646-8.343c1.259-5.939,2.196-7.892,2.791-8.435l5.943-7.252l0.688-0.975L391.256,792.141z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st15",
  cx: 443.692,
  cy: 429.671,
  rx: 21.201,
  ry: 21.028
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M426.829,427.034c0,0-3.778,37.406-8.606,40.043c-4.828,2.637,37.154,5.344,37.154,5.344 s-10.215-34.144-6.997-37.406C451.598,431.823,426.829,427.034,426.829,427.034z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st49",
  d: "M470.7,586.651c-0.77,2.776-1.469,5.413-2.169,7.842c-3.498,0.902-9.516-0.347-15.813-2.429l1.329-17.003 C461.254,577.421,468.181,581.099,470.7,586.651z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M467.621,427.312c0.56-0.208,1.05-0.555,1.539-0.902c1.189-1.11,0.98-2.984,0.49-4.511 c-0.49-1.527-1.259-3.123-0.91-4.65c0.14-0.694,0.56-1.388,0.7-2.151c0.28-1.735-1.119-3.331-2.729-4.233 c-1.539-0.833-3.358-1.319-4.828-2.29c-2.239-1.527-3.498-4.233-5.807-5.76c-2.239-1.457-5.108-1.527-7.767-1.527h-7.977 c-4.198,0-8.746,0.139-11.895,2.915c-0.98,0.833-1.679,1.874-2.659,2.707c-1.959,1.666-4.548,2.36-6.647,3.748 c-3.219,2.151-5.178,5.76-5.108,9.646c0.07,3.539,1.819,6.94,1.329,10.41c-0.28,2.36-1.609,4.58-1.259,6.94 c0.42,2.776,2.939,4.789,5.598,5.76c2.659,1.041,5.528,1.388,8.046,2.568c2.099,0.972,4.268,2.498,6.437,1.804 c1.889-0.555,2.869-2.498,3.568-4.372c0.77-2.151,1.329-4.303,1.679-6.524c0.28-1.666,0.42-3.47,1.469-4.789 c1.189-1.527,3.079-2.36,4.968-2.151c4.338,0.347,6.717,7.703,10.705,5.968c1.959-0.833,3.498-3.401,5.038-4.789 C463.423,429.671,465.452,428.353,467.621,427.312z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st49",
  d: "M468.614,586.651c-0.77,2.776-1.469,5.413-2.169,7.842c-3.498,0.902-9.516-0.347-15.813-2.429 l1.329-17.003C459.168,577.421,466.095,581.099,468.614,586.651z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M472.099,465.967c0,0-15.043-14.435-32.326-11.728c-17.282,2.707-29.597,5.899-29.597,5.899 s-26.378,13.88-26.938,25.122c-0.56,11.243,9.656,53.368,9.656,53.368s4.828,68.913,5.388,68.913s90.96-1.041,90.96-1.041 l-16.723-89.733L472.099,465.967z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M467.488,594.493c-3.498,0.902-9.516-0.347-15.813-2.429c-11.195-3.678-23.23-9.716-23.23-9.716 s-38.763-15.476-50.098-23.526c-11.335-7.981-3.778-40.043-3.778-40.043l17.212,5.344l-1.05,19.779l42.541,27.204 c6.717,0.625,13.294,1.943,19.661,3.956c7.137,2.36,14.134,5.968,16.653,11.59c0.42,0.833,0.7,1.735,0.84,2.707 C470.987,592.273,469.797,593.869,467.488,594.493z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M462.933,508.716l-3.219,28.315l-5.388,69.815c0,0-29.667,35.393-12.944,36.434 c16.723,1.041,25.819-34.699,25.819-34.699s16.723-56.629,16.163-68.358c-0.56-11.728,0-31.507,0-31.507L462.933,508.716z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M464.326,460.428c0,0,16.379,0.195,19.038,18.378c1.679,12.214,2.589,24.498,2.659,36.851 c0,0-18.332-8.536-26.378,0L464.326,460.428z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M392.37,471.899c0,0-13.47,12.25-17.738,27.171c-4.338,14.921-2.659,25.122-2.659,25.122l22.6,3.748 L392.37,471.899z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "a12144e9-3c86-4872-a88a-b0ed4a062895_2_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st50",
  points: "385.479,775.138 379.531,793.876 397.863,795.472 396.254,775.138  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st50",
  points: "473.967,787.125 473.967,808.98 494.759,808.98 488.888,787.125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st51",
  d: "M399.473,603.238l-8.606,81.197c0,0-10.775,71.55-8.606,82.793s-0.56,12.839-0.56,12.839h16.163 c0,0-0.56-6.94,2.659-10.132s1.609-12.839,1.609-12.839l40.932-123.946l23.16,69.399c0,0,3.778,76.339,4.338,77.449 c0.56,1.11,1.567,10.352,1.567,10.352l19.633-1.399c0,0-1.748-2.013,1.96-4.719c3.708-2.707,6.997-0.555,3.778-5.344 c-3.219-4.789-4.338-10.687-3.219-13.325c1.05-2.637,1.05-13.325,1.05-13.325s-1.609-144.141-10.775-148.999 C475.389,598.38,399.473,603.238,399.473,603.238z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st52",
  d: "M480.255,796.873c0,0-6.472-2.112-6.472-1.522s-9.984,20.062,1.512,19.556 c11.496-0.59,29.704,1.791,26.794-11.524c-2.91-13.315-13.124-10.565-13.124-10.565l3.659,0.178L480.255,796.873z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st52",
  d: "M391.327,792.141c0,0,7.866-1.388,7.866-0.902s8.643,23.13-0.773,22.714 c-9.416-0.486-28.97,2.622-26.646-8.343c1.259-5.939,2.196-7.892,2.791-8.435l5.943-7.252l0.688-0.975L391.327,792.141z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st50",
  cx: 443.763,
  cy: 429.671,
  rx: 21.201,
  ry: 21.028
}), /*#__PURE__*/React.createElement("path", {
  className: "st50",
  d: "M426.9,427.034c0,0-3.778,37.406-8.606,40.043c-4.828,2.637,37.154,5.344,37.154,5.344 s-10.215-34.144-6.997-37.406C451.67,431.823,426.9,427.034,426.9,427.034z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st53",
  d: "M470.771,586.651c-0.77,2.776-1.469,5.413-2.169,7.842c-3.498,0.902-9.516-0.347-15.813-2.429 l1.329-17.003C461.325,577.421,468.252,581.099,470.771,586.651z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st54",
  d: "M467.693,427.312c0.56-0.208,1.05-0.555,1.539-0.902c1.189-1.11,0.98-2.984,0.49-4.511 c-0.49-1.527-1.259-3.123-0.91-4.65c0.14-0.694,0.56-1.388,0.7-2.151c0.28-1.735-1.12-3.331-2.729-4.233 c-1.539-0.833-3.359-1.319-4.828-2.29c-2.239-1.527-3.498-4.233-5.807-5.76c-2.239-1.457-5.108-1.527-7.767-1.527h-7.977 c-4.198,0-8.746,0.139-11.895,2.915c-0.98,0.833-1.679,1.874-2.659,2.707c-1.959,1.666-4.548,2.36-6.647,3.748 c-3.219,2.151-5.178,5.76-5.108,9.646c0.07,3.539,1.819,6.94,1.329,10.41c-0.28,2.36-1.609,4.58-1.259,6.94 c0.42,2.776,2.939,4.789,5.598,5.76c2.659,1.041,5.528,1.388,8.046,2.568c2.099,0.972,4.268,2.498,6.437,1.804 c1.889-0.555,2.869-2.498,3.568-4.372c0.77-2.151,1.329-4.303,1.679-6.524c0.28-1.666,0.42-3.47,1.469-4.789 c1.189-1.527,3.079-2.36,4.968-2.151c4.338,0.347,6.717,7.703,10.705,5.968c1.959-0.833,3.498-3.401,5.038-4.789 C463.494,429.671,465.523,428.353,467.693,427.312z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st53",
  d: "M468.685,586.651c-0.77,2.776-1.469,5.413-2.169,7.842c-3.498,0.902-9.516-0.347-15.813-2.429 l1.329-17.003C459.24,577.421,466.167,581.099,468.685,586.651z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st55",
  d: "M472.171,465.967c0,0-15.043-14.435-32.326-11.728c-17.282,2.707-29.597,5.899-29.597,5.899 s-26.378,13.88-26.938,25.122s9.656,53.368,9.656,53.368s4.828,68.913,5.388,68.913c0.56,0,90.96-1.041,90.96-1.041 l-16.723-89.733L472.171,465.967z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st50",
  d: "M467.559,594.493c-3.498,0.902-9.516-0.347-15.813-2.429c-11.195-3.678-23.23-9.716-23.23-9.716 s-38.763-15.476-50.098-23.526c-11.335-7.981-3.778-40.043-3.778-40.043l17.212,5.344l-1.05,19.779l42.541,27.204 c6.717,0.625,13.294,1.943,19.661,3.956c7.137,2.36,14.134,5.968,16.653,11.59c0.42,0.833,0.7,1.735,0.84,2.707 C471.058,592.273,469.868,593.869,467.559,594.493z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st56",
  d: "M469.728,586.651c-0.77,2.776-1.469,5.413-2.169,7.842c-3.498,0.902-9.516-0.347-15.813-2.429 l1.329-17.003C460.282,577.421,467.209,581.099,469.728,586.651z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st50",
  d: "M463.005,508.716l-3.219,28.315l-5.388,69.815c0,0-29.667,35.393-12.944,36.434 c16.723,1.041,25.819-34.699,25.819-34.699s16.723-56.629,16.163-68.358c-0.56-11.728,0-31.507,0-31.507L463.005,508.716z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st57",
  d: "M464.398,460.428c0,0,16.379,0.195,19.038,18.378c1.679,12.214,2.589,24.498,2.659,36.851 c0,0-18.332-8.536-26.378,0L464.398,460.428z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st57",
  d: "M392.441,471.899c0,0-13.47,12.25-17.738,27.171c-4.338,14.921-2.659,25.122-2.659,25.122l22.6,3.748 L392.441,471.899z"
})))), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 257.256,
  y1: 817.504,
  x2: 1253.584,
  y2: 817.504
}));

var SvgGuyGazingUniv2001 = function SvgGuyGazingUniv2001(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1410.486 959.575",
    style: {
      enableBackground: "new 0 0 1410.486 959.575"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Board_Content"
  }, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      mask: "url(#SVGID_2_)"
    }
  }, _ref9, _ref10), _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18), _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuyGazingUniv2001, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GuyGazingUniv2-0-01.6c07c07b.svg";
export { ForwardRef as ReactComponent };